import {NavigationPathKey, TranslationKey} from '@enums'
import {Grid} from '@mui/material'
import {SearchTableWrapper} from '@wrappers'

import React from 'react'

import {renderFormField} from 'common'

import {ComposedComponents, UIKit} from '@components'

import {ParentCompanyTab, useParentCompanyViewModel} from './parent-company-view-model'

/**
 * Parent Company View page
 */
export function ParentCompanyViewPage() {
  const {
    parentCompanyGeneralFormFields,
    isEditButtonVisible,
    t,
    activeTab,
    tabButtons,
    showCreateButton,
    companyColumns,
    companyRows,
    onPressBack,
    onPressEdit,
    navigate,
  } = useParentCompanyViewModel()

  return (
    <>
      <ComposedComponents.TabButtons activeTab={activeTab} buttons={tabButtons} />
      {activeTab === ParentCompanyTab.GENERAL && (
        <>
          <UIKit.BackgroundCard>
            <Grid container spacing={2}>
              {parentCompanyGeneralFormFields.map((item, index) => (
                <Grid item sm={6} key={`parent-company-general-form-field-${index}`}>
                  {renderFormField(item)}
                </Grid>
              ))}
            </Grid>
          </UIKit.BackgroundCard>

          <ComposedComponents.FormButtons
            leftButton={{
              label: t(TranslationKey.Back),
              onClick: onPressBack,
            }}
            {...(isEditButtonVisible && {rightButton: {label: t(TranslationKey.Edit), onClick: onPressEdit}})}
          />
        </>
      )}

      {activeTab === ParentCompanyTab.COMPANIES && (
        <SearchTableWrapper>
          <UIKit.Table
            {...(showCreateButton && {
              buttonProps: {
                buttonText: t(TranslationKey['Add new company']),
                onClick: () => navigate(NavigationPathKey.COMPANY_CREATION),
              },
            })}
            columns={companyColumns}
            rows={companyRows}
            title={t(TranslationKey.Companies)}
          />
        </SearchTableWrapper>
      )}
    </>
  )
}
